// UI strings for the listening transcripts (listen/Transcript.tsx: the text of a recording, hidden
// until asked for) and for the two voices of a show line in practice (showclips/BothVoices.tsx:
// Peterson's recording, the model, and the actor's, listening only). Finnish (default) and English
// side by side; en has the same shape. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const transcriptsFi = {
  show: 'Näytä teksti',
  hide: 'Piilota teksti',
  /** The accessible name when a list has many lines: "Näytä teksti: Daenerys". */
  showOf: (who: string) => `Näytä teksti: ${who}`,
  hideOf: (who: string) => `Piilota teksti: ${who}`,
  /** The page's one switch (remembered on this device). */
  all: 'Näytä kaikki tekstit',
  /** Beside Peterson's player when the actor's clip is offered too. */
  peterson: 'Peterson · malli',
  both: 'Repliikin äänitteet',
};

export const transcriptsEn: typeof transcriptsFi = {
  show: 'Show text',
  hide: 'Hide text',
  showOf: (who: string) => `Show text: ${who}`,
  hideOf: (who: string) => `Hide text: ${who}`,
  all: 'Show all texts',
  peterson: 'Peterson · the model',
  both: 'Recordings of the line',
};

// Messages.transcripts (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('transcripts', transcriptsFi, transcriptsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof transcriptsFi> {}
}
